import { chunkArray } from '@assets/ts/chunkArray';
import React from 'react';
export default function CardStats({ image, logo, values, bg }) {
    const chunks = chunkArray(values, 6);
    return (React.createElement("div", { className: "ltg-card-stats" },
        React.createElement("div", { className: "ltg-card-stats-img-wrap" },
            React.createElement("img", { src: image === null || image === void 0 ? void 0 : image.url, alt: (image === null || image === void 0 ? void 0 : image.alt) || 'Lietuvos Geležinkeliai', className: "ltg-card-stats-img" })),
        React.createElement("div", { className: `ltg-card-stats-values${bg != 'grey' ? ` bg-${bg}` : ''}` },
            (logo === null || logo === void 0 ? void 0 : logo.url) && React.createElement("div", { className: "ltg-card-stats-logo-wrap" }, logo.url && React.createElement("img", { src: logo.url, alt: logo.url || 'Lietuvos Geležinkeliai' })),
            React.createElement("div", { className: "ltg-card-stats-values-content" },
                React.createElement(Chunks, null)))));
    function Chunks() {
        return (React.createElement(React.Fragment, null, chunks === null || chunks === void 0 ? void 0 : chunks.map((items) => {
            return (React.createElement("div", { className: "ltg-card-stats-chunk", key: items[0]._id + 'siblings' },
                React.createElement(Items, { items: items })));
        })));
    }
    function Items({ items }) {
        return (React.createElement(React.Fragment, null, items === null || items === void 0 ? void 0 : items.map(({ label, value, _id }) => {
            return (React.createElement("div", { className: "ltg-card-stats-item", key: _id },
                React.createElement("div", { className: "ltg-card-stats-value" }, value),
                React.createElement("div", { className: "ltg-card-stats-label" }, label)));
        })));
    }
}
